if (typeof GLOBAL_SCRIPTS.HAS_SEE_MORE_CRITICAL === 'undefined') {
  import(/* webpackChunkName: 'components/seeMore' */'./seeMore.css');
}

export const seeMore = {
  init() {
    $('.seeMore-Container').each((_index, item) => {
      const $item = $(item);

      if ($item.find('.seeMore-text').height() > 60) {
        $item.find('.seeMore-text').next().removeClass('hidden');
      }
    });

    $('.js-seeMoreTruncate').off().on('click', (e) => {
      $(e.currentTarget).closest('.seeMore-Container').toggleClass('open').find('.js-seeMoreTruncate').toggleClass('hidden');
    });
  }
};